import { HubState } from 'pages/store/reducers/hub';
import { LabelSize } from 'root/apps/label/utils/types';

import { HUB_OPTIONS, LEGACY_HUB_OPTIONS } from './options';

import { generateRandomString } from '.';

const LEGACY_HUB_ENABLED = 'CFD_ENABLED';
export const HUB_ENABLED = 'HUB_ENABLED';
const HUB_CONNECTED_ONCE = 'HUB_CONNECTED_ONCE';
export const HUB_SMART_CONNECTION = 'HUB_SMART_CONNECTION';
export const HUB_SMART_PRINT = 'HUB_SMART_PRINT';
export const LABEL_SIZE = 'LABEL_SIZE';
export const LABEL_DISPLAY_PRICE = 'LABEL_DISPLAY_PRICE';
export const LABEL_BARCODE_DISPLAY_OPTION = 'LABEL_BARCODE_DISPLAY_OPTION';
export const LABEL_BARCODE_TYPE = 'LABEL_BARCODE_TYPE';
export const LABEL_CONTENT = 'LABEL_CONTENT';
export const LABEL_CONTENT_DEFAULT = 'LABEL_CONTENT_DEFAULT';

export type LocalStorageKeys =
| typeof LEGACY_HUB_ENABLED
| typeof HUB_ENABLED
| typeof HUB_CONNECTED_ONCE
| typeof HUB_SMART_CONNECTION
| typeof HUB_SMART_PRINT
| typeof LABEL_SIZE
| typeof LABEL_DISPLAY_PRICE
| typeof LABEL_BARCODE_DISPLAY_OPTION
| typeof LABEL_BARCODE_TYPE
| typeof LABEL_CONTENT
| typeof LABEL_CONTENT_DEFAULT
| 'HUB_PREVIOUS_SUCCESSFUL_CONNECTION_TO_CLIENT'
// eslint-disable-next-line prettier/prettier
  |  `LABEL_MARGIN_${Uppercase<LabelSize>}`;

export const getHubEnabled = () => !!localStorage.getItem(HUB_ENABLED);

export const setHubEnabled = () => localStorage.setItem(HUB_ENABLED, (true as unknown) as string);

export const removeHubEnabled = () => localStorage.removeItem(HUB_ENABLED);

export const getHubConnectedOnce = () => !!localStorage.getItem(HUB_CONNECTED_ONCE);

export const setHubConnectedOnce = () =>
  localStorage.setItem(HUB_CONNECTED_ONCE, (true as unknown) as string);

export const getHubSmartState = () =>
  safeGetItem<HubState>(HUB_SMART_CONNECTION, undefined, sessionStorage);

export const setHubSmartState = (state: HubState) =>
  safeSetItem(HUB_SMART_CONNECTION, state, sessionStorage);

export const removeHubSmartConnection = () => sessionStorage.removeItem(HUB_SMART_CONNECTION);

const LEGACY_HUB_CHANNEL_NAME = 'CFD_SOCKET_ID';
const HUB_CHANNEL_NAME = 'HUB_CHANNEL_NAME';
const LABEL_DISPLAY_MSRP = 'LABEL_DISPLAY_MSRP';

export const setChannelName = (channelName: string) =>
  localStorage.setItem(HUB_CHANNEL_NAME, channelName);
export const generateChannelName = () => {
  const channelName = generateRandomString(22);
  setChannelName(channelName);
  return channelName;
};
export const getChannelName = () => localStorage.getItem(HUB_CHANNEL_NAME) || generateChannelName();
export const removeChannelName = () => localStorage.removeItem(HUB_CHANNEL_NAME);
export const removeDisplayMsrp = () => localStorage.removeItem(LABEL_DISPLAY_MSRP);


// @Note: As of Hub 0.3.0 the localStorage keys should be prefixed HUB_
export const renameLocalStorageKeys = () => {
  if (localStorage.getItem(LEGACY_HUB_ENABLED)) {
    setHubEnabled();
    localStorage.removeItem(LEGACY_HUB_ENABLED);
  }
  if (localStorage.getItem(LEGACY_HUB_CHANNEL_NAME)) {
    setChannelName(localStorage.getItem(LEGACY_HUB_CHANNEL_NAME)!);
    localStorage.removeItem(LEGACY_HUB_CHANNEL_NAME);
  }
  if (localStorage.getItem(LEGACY_HUB_OPTIONS)) {
    localStorage.setItem(HUB_OPTIONS, localStorage.getItem(LEGACY_HUB_OPTIONS)!);
    localStorage.removeItem(LEGACY_HUB_OPTIONS);
  }

  localStorage.removeItem('DATE_NOW');
};

export const safeGetItem = <Type>(
  key: LocalStorageKeys,
  defaultValue?: Type,
  storage: Storage = localStorage
): Type | undefined => {
  try {
    const item = storage.getItem(key);
    const value = item && getValue(item);

    return value ?? defaultValue;
  } catch (error) {
    console.error(error);
    storage.removeItem(key);
    return defaultValue;
  }
};

export const safeSetItem = <Type>(
  key: LocalStorageKeys,
  value: Type,
  storage: Storage = localStorage
) => {
  try {
    storage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  } catch (error) {
    console.error(error);
    storage.removeItem(key);
  }
};

const getValue = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (_) {
    if (str === 'undefined') {
      return undefined;
    }
    return str;
  }
};
